/*
|-------------------------------------------------------------------------------
| 申卡通用
|-------------------------------------------------------------------------------
*/
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'

/**
 * store
 */
const CreditCommonStore = defineStore({
  state: () => ({
    page: '', // 查询下一页时后端返回的页面标识
    scenes: '', // 查询下一页时后端返回的场景参数
    lastPage: '', // 上一页 用于埋点
  }),
  mutations: {
    update(state, data) {
      Object.assign(state, data)
    },
    updateScenes(state, data) {
      data && (state.scenes = data)
    },
  },
})

export default CreditCommonStore
export type ICreditCommonStoreState = IStoreState<
  typeof CreditCommonStore.state
>
